import { Component, Input, inject, ViewChild, TemplateRef, HostListener, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { GlobalService } from '../../services/global.service';
import { UserService } from '../../services/user.service';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'app-header',
  imports: [CommonModule, RouterModule, MatIconModule],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header {
  public globalService = inject(GlobalService);
  private userService = inject(UserService);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  private elementRef = inject(ElementRef);
  public layout = inject(LayoutService);

  @ViewChild('confirmLogoutDialog') confirmLogoutDialog!: TemplateRef<any>;

  @Input() liveScoreMenu: any = null;
  showProfileMenu = false;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showProfileMenu = false;
    }
  }

  toggleProfileMenu() {
    this.showProfileMenu = !this.showProfileMenu;
  }

  openProfile() {
    this.showProfileMenu = false;
    const userDetails = this.userService.getUserDetails();
    const userId = userDetails?.id || this.globalService.getItem('id');
    this.router.navigate(['/profile'], { queryParams: { userId: userId } });
  }

  get UserRole(): string {
    const roles = this.globalService.userRole();
    if (!roles || roles.length === 0) return '';
    return roles.map((r: any) => r.user_type_name || r.name || r.role_name).filter(Boolean).sort().join(', ');
  }

  logout() {
    this.dialog.open(this.confirmLogoutDialog, {
      width: '380px',
      panelClass: 'modern-confirm-dialog'
    });
  }

  confirmLogout() {
    sessionStorage.clear();
    this.globalService.MatchId.set(0);
    this.globalService.RemainingTime.set(0);
    this.globalService.DivisionId.set(0);
    this.dialog.closeAll();
    this.router.navigate(['/login']);
    window.location.reload();
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  openLiveScore(menu: any, event: Event) {
    if (event) event.preventDefault();
    const url = this.router.serializeUrl(this.router.createUrlTree(['/dashboard']));
    window.open(url, '_blank');
  }

}
